export function getMixedFilterItemRef({
  isCollapsedRow,
  index,
  mediaCount,
  itemsMediaRef,
  itemsProductsRef,
}) {
  if (!isCollapsedRow) {
    return itemsMediaRef?.current?.[index];
  }
  if (index < mediaCount) {
    return itemsMediaRef?.current?.[index];
  }
  return itemsProductsRef?.current?.[index - mediaCount];
}
